import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "crosstab-chart" }
const _hoisted_2 = { class: "font-weight-medium" }
const _hoisted_3 = { class: "cell-content" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = {
  key: 0,
  class: "attitude"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_table, null, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("th", { class: "text-left" }, "Criteria / Stakeholders", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stakeholders, (stakeholder) => {
              return (_openBlock(), _createElementBlock("th", {
                key: stakeholder.id,
                class: "text-center"
              }, _toDisplayString(stakeholder.name), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criterions, (criterion) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: criterion.id
            }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(criterion.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stakeholders, (stakeholder) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `${criterion.id}-${stakeholder.id}`,
                  class: "text-center count-cell",
                  style: _normalizeStyle({ backgroundColor: _ctx.getCountColor(_ctx.getCellCount(criterion.id, stakeholder.id)) })
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getCellCount(criterion.id, stakeholder.id)), 1),
                    (_ctx.getCellCount(criterion.id, stakeholder.id) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getAttitude(criterion.id, stakeholder.id).toFixed(2)), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
              }), 128))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}